import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueTour from '@/page/components/VueTour/main.js';
// 修改登录过期默认跳转页面
Vue.config.productionTip = false;
const {
    Utils,
    TumsLazy
} = window['tums-components'].default;

const { registerLanguage, $t } = Utils.language;
(Vue as any).prototype.$t = $t;
registerLanguage(require('./language/wlanPlannerError.ts'));

Vue.use(Utils.date.default.install);
Vue.use(TumsLazy);
Vue.use(VueTour);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
